import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../components/snackbar/snackbar.component';
import { NotificationType } from '../enums/notificationType';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private snackBar: MatSnackBar) {}

  show(title: string, message: string, notificationType: NotificationType) {
    const menuElement = document.getElementById('menu-desktop-left');
    const isMenuVisible = menuElement && getComputedStyle(menuElement).display !== 'none';

    let horizontalPosition: MatSnackBarHorizontalPosition = 'start';
    let verticalPosition: MatSnackBarVerticalPosition = 'bottom';
    let duration: number | undefined = Math.max(1000, message.length * 60);
    let panelClass: string[] = isMenuVisible ? ['snackbar-left-offset-desktop'] : [];

    switch (notificationType) {
      case NotificationType.Info:
      case NotificationType.Success:
        if (!isMenuVisible) {
          panelClass = [...panelClass, 'snackbar-bottom-offset-mobile'];
        }

        break;
      case NotificationType.Error:
      case NotificationType.Warning:
        duration = undefined;
        horizontalPosition = 'center';
        verticalPosition = 'top';

        if (!isMenuVisible) {
          panelClass = [...panelClass, 'snackbar-top-offset-mobile'];
        }
        break;
    }

    this.snackBar.openFromComponent(SnackBarComponent, {
      horizontalPosition: horizontalPosition,
      verticalPosition: verticalPosition,
      panelClass: panelClass,

      data: {
        title: title,
        message: message,
        notificationType: notificationType,
        duration: duration
      }
    });
  }
}
